<div
  (mouseenter)="onEnter($event)"
  (mouseleave)="onLeave($event)"
  class="bg-black rounded-xl w-80 h-auto overflow-hidden text-white">
  <div class="w-full h-48">
    @if (tooltipData.img) {
      <div
        (click)="load3dView()"
        class="bg-cover bg-no-repeat bg-center h-full viewer3d-image"
        [style.background-image]="'url(' + tooltipData.img + ')'">
        <span>Click to open view</span>
      </div>
    }
    @if (!tooltipData.img) {
      <div class="flex justify-center items-center w-full h-full">
        <div class="lds-dual-ring"></div>
      </div>
    }
  </div>

  <div class="px-3 py-2">
    <div class="flex">
      <div class="mr-5 w-1/2">
        @if (sectionData.mmcID) {
          <h5>
            <span class="font-normal">Section:</span>
            {{ sectionData.mmcID.split('_')[1] }}
          </h5>
        }
        @if (isTicketFeeEnabled && priceRangeWithFees) {
          <h5>
            <span class="font-normal">Price:</span> $ {{ priceRangeWithFees }}
          </h5>
        } @else {
          <h5><span class="font-normal">Price:</span> $ {{ price }}</h5>
        }
      </div>
      <div class="w-1/2 min-w-max text-right">
        <h5>
          <span class="font-normal">Available Seats:</span>
          {{ sectionData.availableQuantity }}
        </h5>
        <h5>
          <span class="font-normal">Available ADA Seats:</span>
          {{ adaQuantity }}
        </h5>
      </div>
    </div>
    <div class="flex justify-center py-2">
      <button
        class="md:hidden block disabled:opacity-30 mr-2 h-9 text-xs disabled:hover:transform-none hover:scale-95 transition-transform btn-main"
        (click)="selectSectionForBA()">
        @if (includedSectionForBA) {
          <span>Deselect</span>
        } @else {
          <span>Select</span>
        }
      </button>
      @if (
        tooltipData.section !== 'S_BLCHADA' &&
        tooltipData.section !== 'S_Bleacher' &&
        tooltipData.type !== 'general_admission'
      ) {
        <button
          class="h-9 text-main hover:text-main-accent text-xs hover:scale-95 transition-transform btn-white"
          (click)="openSeatMap()">
          Open Seat Map
        </button>
      }
    </div>
  </div>
</div>
